import { render } from "./BlacklistMethodAgreementPopup.vue?vue&type=template&id=297c841f&ts=true"
import script from "./BlacklistMethodAgreementPopup.vue?vue&type=script&lang=ts"
export * from "./BlacklistMethodAgreementPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__